define([
    'text!index2021-home/component/image-slick.html',
    // 'common/api',
    'jquery',
    '../common/utils',
    '../../../../vendor/swiper/swiper-bundle.min.js',

    'css!vendor/swiper/swiper-bundle.min.css',
    'css!index2021-home/component/image-slick.css'

], function(
    tpl,
    // Api,
    $,Utils,
    Swiper
){
    return {
        template: tpl,
        data: function(){
            return {
                imageHeight: 0,
                itemInfo: [
                    {nameLeft: 'FINE GOOD',nameRight: '好物合集'},
                    {nameLeft: 'NEW ARRIVAL',nameRight: '新品推荐'},
                    {nameLeft: 'RECOMMEND',nameRight: '推荐合集'}
                ]
            };
        },
        // 这里是传入的数据
        props: {
            theType: {
                type: Number
            },
            SlickImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            dotsShow: {
                type: Number
            },
            SwipersImages: {
                type: Array,
                default: function () {
                    return []
                }
            },
            SwiperType: String
        },
        methods: {
            init: function () {
                this.initss();
            },
            initss: function () {
                var obj = this;
                obj.imageHeight = $(window).width()/9*2;
                setTimeout(function () {
                    if(obj.SwiperType=='thehome'){
                        new Swiper('#swiper-home',{
                            direction: 'vertical',
                            slidesPerView: 1,
                            mousewheel: true,
                            freeMode: true
                        });
                    }
                },2000);

            }
        },
        watch: {
            SwipersImages: function () {
                var obj = this;
                if(obj.SwipersImages){
                    obj.initss();
                }
            }
        },
        mounted: function(){
            // this.initss();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-home/component/image-slick.js
// module id = 270
// module chunks = 6